import type { ContentType } from './contentTypeConstants.ts';
import { VALID_OPERATION_TARGETS } from './contentTypeConstants.ts';

export type Operation =
	| {
			operation?: string | null;
			targetType?: string | null;
	  }
	| null
	| undefined;

type ContentTypes = string | null | undefined;

const isValidContentType = (contentType: ContentTypes): boolean => {
	if (!contentType) {
		return false;
	}
	return VALID_OPERATION_TARGETS.includes(contentType as ContentType);
};

export const canArchiveContent = (operations: Operation[] | null | undefined): boolean => {
	if (operations) {
		return operations.some((singleOperation) => {
			return (
				isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'archive'
			);
		});
	}
	return false;
};

export const canDeleteContent = (operations: Operation[] | null | undefined): boolean => {
	if (operations) {
		return operations.some((singleOperation) => {
			return (
				isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'delete'
			);
		});
	}
	return false;
};

export const canRestoreContent = (operations: Operation[]): boolean =>
	canArchiveContent(operations);

export const canEditContentArchiveNote = (operations: Operation[]): boolean =>
	canArchiveContent(operations);
